import React from "react";

import GenericIntegrationCard from "../GenericIntegrationCard";
import DesktopSyncIcon from "../../../../common/icons/integrations/DesktopSyncIcon";
import { INTEGRATION_KEYS } from "../../../../integrations/IntegrationsHelper";
import steps from '../../../../integrations/onboarding/steps';

export default function DesktopIntegrationCard({ controller }) {
  return (
    <GenericIntegrationCard
      controller={controller}
      integrationType={INTEGRATION_KEYS.desktop}
      integrationStep={steps.desktop}
      IconTag={DesktopSyncIcon}
      title="Mana needs the Desktop App to work"
      description="To receive custom insights, you need to download and install our desktop app."
    />
  );
}
